import {APP} from 'jsAssets/constants/app';
import _u from "jsAssets/utils/index";

// initial state
const state = {
    projectTotalSum: null,
    projectItems: null,
    projectMessages: null,
    createProjectFormSchema: null,
    projectNameSchema: null,
    projectPhoneSchema: null,
    projectSelfSchema: null,
    projectAddressSchema: null,
    projectEmailSchema: null,
    projectDiscountSchema: null,
    projectTransferSchema: null,
    projectNotesSchema: null,
    projectLogoSchema: null,
};

// getters
const getters = {
    projectTotalSum: state => state.projectTotalSum,
    projectItems: state => state.projectItems,
    projectSelfSchema: state => state.projectSelfSchema,
    projectMessages: state => state.projectMessages,
    createProjectFormSchema: state => state.createProjectFormSchema,
    projectNameSchema: state => state.projectNameSchema,
    projectPhoneSchema: state => state.projectPhoneSchema,
    projectAddressSchema: state => state.projectAddressSchema,
    projectEmailSchema: state => state.projectEmailSchema,
    projectDiscountSchema: state => state.projectDiscountSchema,
    projectTransferSchema: state => state.projectTransferSchema,
    projectNotesSchema: state => state.projectNotesSchema,
    projectLogoSchema: state => state.projectLogoSchema,
};

// actions
const actions = {
    getItems({ commit }, item) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectList',
            'projectId': item.projectId,
            'selfSelect': item.selfSelect,
            'photoSelect': item.photoSelect
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectItems', responseData.data.data.projectItems);
            commit('setProjectTotalSum', responseData.data.data.projectTotalSum);
            commit('setProjectMessages', responseData.data.data.projectMessages);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    removeProduct({ commit }, item) {
        let params = {
            'handler': 'projects',
            'func': 'removeProduct',
            'productId': item.productId,
            'projectId': item.projectId,
            'selfSelect': item.selfSelect
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectItems', responseData.data.data.projectItems);
            commit('setProjectTotalSum', responseData.data.data.projectTotalSum);
            commit('setProjectMessages', responseData.data.data.projectMessages);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    deleteProject({ commit }, item) {
        let params = {
            'handler': 'projects',
            'func': 'deleteProject',
            'projectId': item.projectId,
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectItems', responseData.data.data.projectItems);
            commit('setProjectTotalSum', responseData.data.data.projectTotalSum);
            commit('setProjectMessages', responseData.data.data.projectMessages);
            commit('app/setLoadingData', false, { root: true });
            if (responseData.data.data.delete == 'deleted')
                window.location.href = item.link;
        });
    },

    changeQuantity({ commit }, item) {
        let params = {
            'handler': 'projects',
            'func': 'changeQuantity',
            'productId': item.productId,
            'projectId': item.projectId,
            'quantity': item.quantity
        };
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectItems', responseData.data.data.projectItems);
            commit('setProjectTotalSum', responseData.data.data.projectTotalSum);
            commit('setProjectMessages', responseData.data.data.projectMessages);
        });
    },

    addProduct({ commit }, item) {
        let params = {
            'handler': 'projects',
            'func': 'addProduct',
            'productId': item.productId,
            'projectId': item.projectId,
            'quantity': item.quantity
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectItems', responseData.data.data.projectItems);
            commit('setProjectTotalSum', responseData.data.data.projectTotalSum);
            commit('setProjectMessages', responseData.data.data.projectMessages);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getCreateProjectFormSchema({ commit }, lang) {
        let params = {
            'handler': 'projects',
            'func': 'getCreateProjectFormSchema',
            'lang': lang,
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setCreateProjectFormSchema', responseData.data.data.createProjectFormSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectNameSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectNameSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectNameSchema', responseData.data.data.projectNameSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectDiscountSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectDiscountSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectDiscountSchema', responseData.data.data.projectDiscountSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectTransferSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectTransferSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectTransferSchema', responseData.data.data.projectTransferSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectLogoSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectLogoSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectLogoSchema', responseData.data.data.projectLogoSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectNotesSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectNotesSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectNotesSchema', responseData.data.data.projectNotesSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectPhoneSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectPhoneSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectPhoneSchema', responseData.data.data.projectPhoneSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectSelfSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectSelfSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectSelfSchema', responseData.data.data.projectSelfSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectAddressSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectAddressSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectAddressSchema', responseData.data.data.projectAddressSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    getProjectEmailSchema({ commit }, projectId) {
        let params = {
            'handler': 'projects',
            'func': 'getProjectEmailSchema',
            'projectId': projectId
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectEmailSchema', responseData.data.data.projectEmailSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    renameProject({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'renameProject',
            'projectId': project.projectId,
            'newProjectName': project.newProjectName
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectNameSchema', responseData.data.data.projectNameSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    changeProjectPhone({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'changeProjectPhone',
            'projectId': project.projectId,
            "firstTime": project.firstTime,
            'newProjectPhone': project.newProjectPhone
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectPhoneSchema', responseData.data.data.projectPhoneSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    changeProjectNotes({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'changeProjectNotes',
            'projectId': project.projectId,
            'newProjectNotes1': project.newProjectNotes1,
            'newProjectNotes2': project.newProjectNotes2,
            'newProjectNotes3': project.newProjectNotes3
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectNotesSchema', responseData.data.data.projectNotesSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    changeProjectAddress({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'changeProjectAddress',
            'projectId': project.projectId,
            "firstTime": project.firstTime,
            'newProjectAddress': project.newProjectAddress
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectAddressSchema', responseData.data.data.projectAddressSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    changeProjectLogo({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'changeProjectLogo',
            'projectId': project.projectId,
            'newProjectLogo': project.newProjectLogo
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectLogoSchema', responseData.data.data.projectLogoSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    addProjectToBasket({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'addProjectToBasket',
            'projectItems': project.projectItems,
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            _u.redirect(responseData.data.data);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    changeProjectDiscount({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'changeProjectDiscount',
            'projectId': project.projectId,
            'newProjectDiscount': project.newProjectDiscount
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectDiscountSchema', responseData.data.data.projectDiscountSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    changeProjectTransfer({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'changeProjectTransfer',
            'projectId': project.projectId,
            'newProjectTransfer': project.newProjectTransfer,
            'selfSelect': project.selfSelect,
            'photoSelect': project.photoSelect
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            console.log(responseData);
            commit('setProjectItems', responseData.data.data.projectItems);
            commit('setProjectTotalSum', responseData.data.data.projectTotalSum);
            commit('setProjectMessages', responseData.data.data.projectMessages);
            commit('app/setLoadingData', false, { root: true });
        });
        // commit('app/setLoadingData', true, { root: true });
        // _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
        //     console.log(2222222)
        //     commit('setProjectTransferSchema', project.newProjectTransfer);
        //     commit('setProjectItems', responseData.data.data.projectItems);
        //     commit('setProjectTotalSum', responseData.data.data.projectTotalSum);
        //     commit('app/setLoadingData', false, { root: true });
        //
        //     // location.reload();
        // });
    },

    changeProjectEmail({ commit }, project) {
        let params = {
            'handler': 'projects',
            'func': 'changeProjectEmail',
            'projectId': project.projectId,
            "firstTime": project.firstTime,
            'newProjectEmail': project.newProjectEmail
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            commit('setProjectEmailSchema', responseData.data.data.projectEmailSchema);
            commit('app/setLoadingData', false, { root: true });
        });
    },

    createProject({ commit }, projectName) {
        let params = {
            'handler': 'projects',
            'func': 'createProject',
            'projectName': projectName
        };
        commit('app/setLoadingData', true, { root: true });
        _u.requestHttp('get', APP.ajax_endpoint, params, (responseData) => {
            if (responseData.data.data.redirectToProject) {
                _u.redirect(responseData.data.data.redirectToProject);
            } else {
                commit('setCreateProjectFormSchema', responseData.data.data.createProjectFormSchema);

                commit('app/setLoadingData', false, { root: true });
            }
        });
    },

};

// mutations
const mutations = {
    setProjectTotalSum (state, projectTotalSum) {
        state.projectTotalSum = projectTotalSum;
    },
    setProjectItems (state, projectItems) {
        state.projectItems = projectItems;
    },
    setProjectMessages (state, projectMessages) {
        state.projectMessages = projectMessages;
    },
    setCreateProjectFormSchema (state, createProjectFormSchema) {
        state.createProjectFormSchema = createProjectFormSchema;
    },
    setProjectNameSchema (state, projectNameSchema) {
        state.projectNameSchema = projectNameSchema;
    },
    setProjectPhoneSchema (state, projectPhoneSchema) {
        state.projectPhoneSchema = projectPhoneSchema;
    },
    setProjectSelfSchema (state, projectSelfSchema) {
        state.projectSelfSchema = projectSelfSchema;
    },
    setProjectAddressSchema (state, projectAddressSchema) {
        state.projectAddressSchema = projectAddressSchema;
    },
    setProjectEmailSchema (state, projectEmailSchema) {
        state.projectEmailSchema = projectEmailSchema;
    },
    setProjectDiscountSchema (state, projectDiscountSchema) {
        state.projectDiscountSchema = projectDiscountSchema;
    },
    setProjectTransferSchema (state, projectTransferSchema) {
        state.projectTransferSchema = projectTransferSchema;
    },
    setProjectNotesSchema (state, projectNotesSchema) {
        state.projectNotesSchema = projectNotesSchema;
    },
    setProjectLogoSchema (state, projectLogoSchema) {
        state.projectLogoSchema = projectLogoSchema;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}